function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "triggerRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { triggerListeners } from '../_utils/triggerListeners';
import { useHotkey } from './Hotkey';

/* TYPES */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

/* HOOK */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function useTrigger(_ref) {
  var disable = _ref.disable,
    _ref$disableKeys = _ref.disableKeys,
    disableKeys = _ref$disableKeys === void 0 ? [] : _ref$disableKeys,
    enable = _ref.enable,
    _ref$enableKeys = _ref.enableKeys,
    enableKeys = _ref$enableKeys === void 0 ? [] : _ref$enableKeys,
    _ref$isEnabled = _ref.isEnabled,
    isEnabled = _ref$isEnabled === void 0 ? false : _ref$isEnabled,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'click' : _ref$trigger,
    triggerRef = _ref.triggerRef;
  triggerListeners({
    off: disable,
    on: enable,
    scope: triggerRef,
    trigger: trigger,
    value: isEnabled
  });
  useHotkey({
    key: enableKeys,
    handler: enable,
    preventDefault: true,
    scope: triggerRef
  });
  useHotkey({
    key: disableKeys,
    handler: disable,
    preventDefault: true,
    scope: triggerRef
  });

  // prevent keyup event from firing on FF
  useHotkey({
    event: 'keyup',
    key: [].concat(_toConsumableArray(enableKeys), _toConsumableArray(disableKeys)),
    handler: function handler() {},
    preventDefault: true,
    scope: triggerRef
  });
  return {
    disable: disable,
    enable: enable,
    isVisible: isEnabled,
    toggle: isEnabled ? disable : enable
  };
}

/* RENDER PROP */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function Trigger(_ref2) {
  var children = _ref2.children,
    triggerRef = _ref2.triggerRef,
    props = _objectWithoutProperties(_ref2, _excluded);
  var trigger = useTrigger(_objectSpread(_objectSpread({}, props), {}, {
    triggerRef: triggerRef
  }));
  var element = typeof children === 'function' ? children(trigger) : children;
  return /*#__PURE__*/React.cloneElement(element, {
    open: trigger.isVisible
  });
}
//# sourceMappingURL=Trigger.js.map